import Api from '../api'
import pythonApi from '../api/pythonApi'
import constants from '../config/constants'
import authStore from '../store/authStore'
import userStore from '../store/userStore'

class SensorService {

    async getAllSensorBoxes(currentPage : number, search :number ){
        let response = await  Api.search(`/sensorboxes/` +
                                        `parent/${this.getParentId()}/?`+
                                        `skip=${(currentPage - 1) * constants.maxLimit}&`+
                                        `limit=${constants.maxLimit}&`+
                                        `filter=${JSON.stringify({search})}`)
            return response.data
    }  

    getParentId(){
 
        if(authStore.currentUser.role === constants.role["Contractor"]){
            return authStore.currentUser.uid    //Contractor can see users under him, Parent id will be his id
        }else if(authStore.currentUser.role > constants.role["Contractor"]){
            return userStore.profileDetials ? userStore.profileDetials.assigned_to?._id : '' //Field Engineer can see users under contractor in which he is assigned to, Parent id 
        }else{
            return ' '
        }

    }


    async sendReport(sensorBoxName : string, startDate? : Date, endDate? : Date ,orgId? : any ){

        let response = await Api.get(`/report/sensorbox?sensorboxname=${sensorBoxName}` +
                                        `${startDate ? '&startDate='+ startDate.getTime() : ' '}` +
                                        `${endDate ? '&endDate='+  endDate.getTime() : ' '} &orgid=${orgId}`)
        return response.data.message
    }

    async sendGroupReport(groupId : string, startDate? : Date, endDate? : Date,orgId? : any){

        let response = await Api.get(`/report/group?groupid=${groupId}` +
                                        `${startDate ? '&startDate='+ startDate.getTime() : ' '}` +
                                        `${endDate ? '&endDate='+  endDate.getTime() : ' '} &orgid=${orgId}`)
        return response.data.message
    }
    
    async getSensorBoxes(currentPage? : number, maxLimit? : number,contractor?:any, searchFilter? : string, deviceSort?: string, statusSort?: string, orgid? : string, system_id ? : any , status ? : any, show_deleted? : boolean, deployment_status? : any, commissioned_date?: any, show_asset_groups? : boolean){
        let searchText = ''
        if(searchFilter) {
            searchText = encodeURIComponent(searchFilter)
        }
        let queryParams = `/sensorboxes-list-new?page=${currentPage}&limit=${maxLimit}&deviceSort=${deviceSort}&statusSort=${statusSort}&filter=${JSON.stringify({search : searchText})}&show_deleted=${show_deleted}`
        if(contractor){
            queryParams += `&contractor=${contractor._id}`
        }
        if(orgid){
            queryParams += `&orgid=${orgid}`
        }

        if(system_id){
            queryParams += `&system_id=${system_id}`
        }

        if(status){
            queryParams += `&status=${status}`
        }

        if(deployment_status){
            queryParams += `&deployment_status=${deployment_status}`
        }

        if(commissioned_date){
            queryParams += `&commissioned_date=${commissioned_date}`
        }

        if(show_asset_groups){
            queryParams += `&show_asset_groups=${show_asset_groups}`
        }

        let response = await Api.cancelPendingAndGet(queryParams)                           
        return response.data
    }
async getSensorBoxesForDemo(currentPage? : number, maxLimit? : number,contractor?:any, searchFilter? : string, deviceSort?: string, statusSort?: string, orgid? : string, system_id ? : any , status ? : any, show_deleted? : boolean, deployment_status? : any, commissioned_date?: any, show_asset_groups? : boolean){
        let searchText = ''
        if(searchFilter) {
            searchText = encodeURIComponent(searchFilter)
        }
        let queryParams = `/sensorboxes-list-demo?page=${currentPage}&limit=${maxLimit}&deviceSort=${deviceSort}&statusSort=${statusSort}&filter=${JSON.stringify({search : searchText})}&show_deleted=${show_deleted}`
        if(contractor){
            queryParams += `&contractor=${contractor._id}`
        }
        if(orgid){
            queryParams += `&orgid=${orgid}`
        }

        if(system_id){
            queryParams += `&system_id=${system_id}`
        }

        if(status){
            queryParams += `&status=${status}`
        }

        if(deployment_status){
            queryParams += `&deployment_status=${deployment_status}`
        }

        if(commissioned_date){
            queryParams += `&commissioned_date=${commissioned_date}`
        }

        if(show_asset_groups){
            queryParams += `&show_asset_groups=${show_asset_groups}`
        }

        let response = await Api.cancelPendingAndGet(queryParams)
        return response.data
    }

    async getSensorBoxNames(){
        let response = await Api.get(`/sensorboxnames/${this.getParentId()}`)
        return response.data
    }

    async checkSensorBoxExist(id:string,sensorBoxName:string) {       
        let response = await Api.get(`/checksensorboxname/${id}/${sensorBoxName}`)
        return response.data.result
    }
   
    
    async enableSensorBox(id:string){
        let response = await Api.post(`/sensorboxes/${id}`,{id}) 
        return response.data.message
    }

    async moveSensorboxToOtherOrganization(datas? : any){
        let response = await Api.post(`/move-sensorbox/${datas?.id}`,datas);
        return response.data.message
    }

    async getGraphData(sensorBoxName : string, startDate? : Date, endDate? : Date, chunkLastTime?: string | null, version? : Number, fields?: string[]){
        let query = `/graph/sensorbox?sensorboxname=${sensorBoxName}&` +
                                        `startDate=${startDate ? startDate.getTime():''}&` +
                                        `endDate=${endDate ? endDate.getTime() : ''}&` +
                                        `lastTime=${chunkLastTime ? chunkLastTime : ''}&` +
                                        `version=${version ? version : '0'}`
        if (fields?.length) {
            query += `&fields=${encodeURIComponent(fields.join(','))}`
        }
        let response = await Api.get(query)
         return response.data && response.data.records ? response.data.records : []
    }

    getSensorRawData = async (sensor_name: string, orgid? : string) => {
        // Migrated to Python API - use getInternalRawData instead
        return await this.getInternalRawData(sensor_name, orgid)
    }

    getInternalRawData = async (sensor_name: string, orgid? : string) => {
        let queryParams = `/api/v1/raw-data/internal?`

        if(sensor_name){
            queryParams += `sensor_name=${sensor_name}&`
        }

        if(orgid){
            queryParams += `orgid=${orgid}`
        }

        const response = await pythonApi.get(queryParams)
        return response.data.result
    }

    getExternalRawData = async (orgid? : string, source: string = 'all') => {
        let queryParams = `/api/v1/raw-data/external?source=${source}`

        if(orgid){
            queryParams += `&orgid=${orgid}`
        }

        const response = await pythonApi.get(queryParams)
        return response.data.result
    }

    getE2SensorData = async (actual_name: string, orgid? : string) => {
        let queryParams = `/e2sensordata?` + ( actual_name !== ''? `actual_name=${actual_name}` : '')

        if(orgid){
            queryParams += `&orgid=${orgid}`
        }

        const response = await Api.get(queryParams)
        return response.data.result
    }

    getE2RecentProps = async () => {
        const response = await Api.get(`/e2recentprops`)
        return response.data.result
    }

    async getE2GraphData(startDate? : Date, endDate? : Date, chunkLastTime?: string | null, props?: string[]){
        let query = `/graph/e2?` +
                                        `startDate=${startDate ? startDate.getTime():''}&` +
                                        `endDate=${endDate ? endDate.getTime() : ''}&` +
                                        `lastTime=${chunkLastTime ? chunkLastTime : ''}`
        if (props?.length) {
            query += `&props=${encodeURIComponent(props.join(','))}`
        }
        let response = await Api.get(query)
         return response.data && response.data.records ? response.data.records : []
    }

    async getSensorBoxConfigHistory(sensorBoxName:string) {       
        let response = await pythonApi.get(`/api/v1/sensorbox-history/${sensorBoxName}`)
        return response.data.result
    }
    async getSensorBoxConfigHistoryForAsset(asset_id:string) {
        let response = await pythonApi.get(`/api/v1/sensorbox-history/group/${asset_id}`)
        return response.data.result
    }

    async getAssetLogs(asset_id:string,pageNumer:Number,limit:Number){
        let response = await Api.get(`/asset-alert-logs/${asset_id}?pageNumber=${pageNumer}&limit=${limit}&type=health-status`)
        return response
    }

    async getAssetMlLogs(asset_id:string,pageNumer:Number,limit:Number){
        let response = await pythonApi.get(`/api/v1/asset-ml-alert-logs/${asset_id}?pageNumber=${pageNumer}&limit=${limit}&type=ml-health-status`)
        return response
    }

    async getSensorAlertLogs(sensorbox_name:string,pageNumer:Number,limit:Number){
        let response = await Api.get(`/sensor-alert-logs/${sensorbox_name}?pageNumber=${pageNumer}&limit=${limit}&type=health-status`)
        return response
    }

    async getHealthAlertChart(logId: string, code: string, sensorbox?: string, description?: string, startDate?: number, endDate?: number) {
        let query = `/health-alert-chart/${logId}?code=${encodeURIComponent(code)}`
        if (sensorbox) {
            query += `&sensorbox=${encodeURIComponent(sensorbox)}`
        }
        if (description) {
            query += `&description=${encodeURIComponent(description)}`
        }
        if (startDate != null && endDate != null) {
            query += `&startDate=${encodeURIComponent(String(startDate))}&endDate=${encodeURIComponent(String(endDate))}`
        }
        const response = await Api.get(query)
        return response.data
    }

    async getPredictionAlertChart(logId: string, sensorbox?: string, startDate?: number, endDate?: number) {
        let query = `/prediction-alert-chart/${logId}`
        const params: string[] = []
        if (sensorbox) {
            params.push(`sensorbox=${encodeURIComponent(sensorbox)}`)
        }
        if (startDate != null && endDate != null) {
            params.push(`startDate=${encodeURIComponent(String(startDate))}`)
            params.push(`endDate=${encodeURIComponent(String(endDate))}`)
        }
        if (params.length) {
            query += `?${params.join('&')}`
        }
        const response = await Api.get(query)
        return response.data
    }

    async getAlertLogs(sensorbox_name:string,pageNumer:Number,limit:Number){
        let response = await Api.get(`/alert-logs/${sensorbox_name}?pageNumber=${pageNumer}&limit=${limit}&type=health-status`)
        return response
    }

    async getLatestAlertLogs(sensorbox_name:string){
        let response = await Api.get(`/latest-alert-logs/${sensorbox_name}?type=health-status`)
        return response
    }

    async getDeviceOfflineLogs(sensorbox_name:string,pageNumer:Number,limit:Number){
        let response = await Api.get(`/alert-logs/${sensorbox_name}?pageNumber=${pageNumer}&limit=${limit}&type=offline-alert-status`)
        return response
    }

    async getValidRangeLogs(sensorbox_name:string,pageNumer:Number,limit:Number){
        let response = await Api.get(`/alert-logs/${sensorbox_name}?pageNumber=${pageNumer}&limit=${limit}&type=invalid-range`)
        return response
    }

    async getSensorboxStateTransitions(sensorbox_name:string, pageNumber:number = 1, limit:number = 50, startDate?:number, endDate?:number){
        let queryParams = `pageNumber=${pageNumber}&limit=${limit}`;
        if (startDate) queryParams += `&startDate=${startDate}`;
        if (endDate) queryParams += `&endDate=${endDate}`;
        let response = await pythonApi.get(`/api/v1/sensorboxes/${sensorbox_name}/state-transitions?${queryParams}`)
        return response
    }

    async getSensorboxStateStatistics(sensorbox_name:string, startDate?:number, endDate?:number){
        let queryParams = '';
        if (startDate) queryParams += `startDate=${startDate}`;
        if (endDate) {
            if (queryParams) queryParams += '&';
            queryParams += `endDate=${endDate}`;
        }
        const url = `/api/v1/sensorboxes/${sensorbox_name}/state-statistics${queryParams ? '?' + queryParams : ''}`;
        let response = await pythonApi.get(url)
        return response
    }

    async getGroupAlertLogs(sensorbox_group:string,pageNumer:Number,limit:Number){
        let response = await Api.get(`/group-alert-logs/${sensorbox_group}?pageNumber=${pageNumer}&limit=${limit}&type=health-status`)
        return response
    }

    async getGroupDeviceOfflineLogs(sensorbox_group:string,pageNumer:Number,limit:Number){
        let response = await Api.get(`/group-alert-logs/${sensorbox_group}?pageNumber=${pageNumer}&limit=${limit}&type=offline-alert-status`)
        return response
    }

    async getDeviceConfigLog(sensorbox_name: string, sno?: string) {
        let response = await Api.get(`/device-config-logs/${sensorbox_name}?sno=${sno}`);
        return response;
    }

    async setOfflineReminder(params : any) {
        let response = await Api.post('/set-offline-reminder',params);
        return response;
    }

    async getEnergyGraphData(id : any, frequencyType? : any, systemType? : any){
        let response = await Api.get(`/graph/energy-system?systemId=${id}&` +
                                    `type=${systemType}&` +
                                    `frequencyType=${frequencyType}`)
        return response.data ? response.data : []
    }

    async getWeather(lat : any, lon? : any){
        let response = await Api.get(`/get-weatherinfo?lat=${lat}&` +
                                    `lon=${lon}`)
        return response.data ? response.data : []
    }

    async getEnergyConsumptionData(id : any, systemType : any, startDate:any, endDate:any,){
        let response = await Api.get(`/graph/energy-consumption-data?systemId=${id}&` +
            `type=${systemType}&` +
            `startDate=${startDate.getTime()}&`+
            `endDate=${endDate.getTime()}`
        )
        return response.data ? response.data : []
    }

    async getWeatherObservationsForSensorbox(sensorBoxName: string, startDate: Date, endDate: Date) {
        const enc = encodeURIComponent(sensorBoxName)
        let response = await pythonApi.get(
            `/api/v1/graph/weather-observe?sensorBoxName=${enc}&startDate=${startDate.getTime()}&endDate=${endDate.getTime()}`
        )
        return response.data ? response.data : []
    }

    async checkExistingTicket(id: string, alertCode: string) {
        let response = await Api.get(`/check-existing-ticket?id=${id}&alert_code=${alertCode}`);
        return response.data;
    }
}

const sensorService = new SensorService()
export default sensorService